import React from 'react'
import { Field, reduxForm } from 'redux-form'
import * as ReactBootstrap from 'react-bootstrap'
import {
  FormButtons,
  renderers,
  validations,
} from '../../components'

const maxLength200 = validations.maxLength(200)
const minLength10 = validations.minLength(10)

let BankDetailsForm = ({
  handleSubmit,
  pristine,
  reset,
  submitting,
}) => {

  return (
    <form onSubmit={handleSubmit}>
      <ReactBootstrap.Row>
        <ReactBootstrap.Col xs={12} md={6}>
          <Field
            name="company_name"
            label="Company Name"
            validate={[validations.required]}
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={12} md={6}>
          <Field
            label="Bank Name"
            name="bank_name"
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={12} md={6}>
          <Field
            label="Account Number"
            name="account_number"
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={12} md={6}>
          <Field
            label="IFSC Code"
            name="ifsc_code"
            component={renderers.renderField}
            validate={[validations.required, minLength10]}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={12} md={6}>
          <Field
            label="UPI ID"
            name="upi_id"
            validate={[validations.required]}
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={12} md={6}>
          <Field
            label="Branch Name"
            name="branch_name"
            validate={[validations.required, minLength10, maxLength200]}
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
        <ReactBootstrap.Row>
        <ReactBootstrap.Col md={12} xs={12} lg={12}>
          <FormButtons
            submitting={submitting}
            pristine={pristine}
            reset={reset}
          />
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
    </form>
  )
}
BankDetailsForm = reduxForm({
  form: 'BankDetailsForm',
})(BankDetailsForm)

export default BankDetailsForm
